var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-ml-5"},[(_vm.isLoading)?_c('gl-loading-icon',{attrs:{"size":"sm","label":_vm.__('Loading pipeline status')}}):(_vm.hasCiStatus)?_c('ci-icon',{attrs:{"status":_vm.ciStatus,"title":_vm.statusTitle,"aria-label":_vm.statusTitle}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }